import { MRTRANS } from "utils/Constants/Constants";

export interface LogItem {
  id: string | number;
  type?: string;
  status?: number | string;
  createdAt?: string | Date;
  updatedAt?: string | Date;
  payload?: any;
  response?: any;
  error?: any;
}

export const phoneRegex = /^(0|\+84)(\d{9,10})$/;

export function getStatusText(status: number | string): string {
  const found = MRTRANS.find(
    (item) => item.value === status || item.key === status,
  );
  return found?.label || "N/A";
}

export function safeParse<T = any>(input: any): T {
  try {
    if (typeof input === "string") {
      return JSON.parse(input) as T;
    }
    return input as T;
  } catch {
    return input as T;
  }
}

export function normalizeLogItem(item: any): any {
  const payload = safeParse(item.payload);
  let response = safeParse(item.response);

  if (response && typeof response.data === "string") {
    response.data = safeParse(response.data);
  }
  if (response?.data?.detail && typeof response.data.detail === "string") {
    response.data.detail = safeParse(response.data.detail);
  }

  return {
    id: item.id,
    type: item.type,
    status: item.status,
    createdAt: item.createdAt,
    updatedAt: item.updatedAt,
    payload,
    response,
    error: item.error,
  };
}
